/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken, prettyHour, tokenMatch } from '../utils/util';
import './Region.css';
import Wrapper from './Wrapper';
import QuickEscapeAdder from './partials/QuickEscapeAdder';
import RoomInfo from './partials/RoomInfo';
import AddToRegionForm from './partials/AddToRegionForm';
import OzModalButton from './partials/OzModalButton';
import {
  getCityInfo,
  listRegions,
  listRooms,
  fetchUser,
} from '../actions';
import EscapeForm from './partials/EscapeForm';


class RoomRow extends Component {
  state = {};

  toggle() {
    let expanded = !this.state.expanded;
    this.setState({ expanded });
  }

  stop(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let companyName = this.props.companyName;
    let room = this.props.room;
    let hayStack = [
      room.name,
      companyName,
    ];

    let minMaxNode;
    if (room.minPeople && room.maxPeople) {
      minMaxNode = (
        <div>{room.minPeople}-{room.maxPeople}</div>
      );
    }
    let cityNode;
    if (room.location && room.location.city) {
      let cityName = room.location.city.name;
      cityNode = <div>{cityName}</div>;
      hayStack.push(cityName);
    }

    let hayStackStr = hayStack.join(' ');
    let matches = true;
    if (this.props.filter) {
      matches = tokenMatch(hayStackStr, this.props.filter);
    }
    if (!matches) return null;

    return (
      <div className={cx('room', { expanded: this.state.expanded })}>
        <div className="room-summary" onClick={() => this.toggle()}>
          <div className="expand">
            <div className="expand-inner">
              <FontAwesome name="caret-right" />
            </div>
          </div>
          <div className="company">{companyName}</div>
          <div className="room">{room.name}</div>
          <div className="city">{cityNode}</div>
          <div className="players">{minMaxNode}</div>
          <div className="controls" onClick={(e) => this.stop(e)}>
            <QuickEscapeAdder room={room} user={this.props.user} />
          </div>
        </div>

        <div className="room-detail">
          <RoomInfo room={this.props.room} />
        </div>
      </div>
    );
  }
}


class CompanyList extends Component {
  render() {
    let companyName = this.props.companyName;
    let rooms = this.props.rooms;
    let nodes = rooms.map(room => <RoomRow
                                    key={room.id}
                                    room={room}
                                    {...this.props}
                                  />);

    return (
      <div className="company">
        <div className="rooms">{nodes}</div>
      </div>
    );
  }
}


class Region extends OzComponent {

  static need = [
    ['regions', listRegions, p => { return { slug: p.slug } }],
    ['rooms', listRooms, p => { return { regionSlug: p.slug } }],
  ];

  state = {};

  renderRegion(region) {
    let rooms = this.props.rooms;
    if (!region || !rooms) return;

    let roomsByCompany = {};
    for (let room of rooms.items) {
      let companyName = room.location.company;
      if (!roomsByCompany[companyName]) {
        roomsByCompany[companyName] = [];
      }
      roomsByCompany[companyName].push(room);
    }

    console.log('roomsByCompany', roomsByCompany);
    let names = Object.keys(roomsByCompany);
    names = names.sort((a, b) => a.localeCompare(b));
    let nodes = names.map(name => <CompanyList
                                    key={name}
                                    filter={this.state.filter}
                                    user={this.props.user}
                                    companyName={name}
                                    rooms={roomsByCompany[name]}
                                    />);
    return (
      <div className="region">
        <div className="filter">
          <input
            type="text"
            value={this.state.filter}
            onChange={ss(this, 'filter')}
            placeholder="Filter..."
          />
        </div>
        <div className="companies">{nodes}</div>
      </div>
    );
  }

  render() {
    let region;
    let title;
    if (this.props.regions && this.props.regions.items.length > 0) {
      region = this.props.regions.items[0]
      title = region.name;
    }

    return (
      <Wrapper className="Region" title={title}>
        {this.renderRegion(region)}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    regions: state.list.region,
    rooms: state.list.room,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Region);



/** WEBPACK FOOTER **
 ** ./src/components/Region.js
 **/